import { ICustomGradient } from 'types/interfaces';

export const AreaChartGradient: ICustomGradient[] = [
    {
        color: 'rgba(234, 242, 255)',
        offset: '0%',
        opacity: 1,
    },
];
